export default __webpack_public_path__ + "static/media/Lu_Feng.f6a3d728.png";